import { render, staticRenderFns } from "./ReferralLanding.vue?vue&type=template&id=a337baa4"
import script from "./ReferralLanding.vue?vue&type=script&lang=js"
export * from "./ReferralLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports